import { z } from 'zod'
import { citizenObject } from '~/packages/general/citizen/citizenObject'
import { residenceObject } from '~/packages/general/residence/residenceObject'
import { heavyMachineryObject } from '~/packages/rural/heavyMachinery/heavyMachineryObject'
import { operatorObject } from '~/packages/rural/operator/operatorObject'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'

export const machineServiceStatus = enumerated({
  pending: 'Pendente',
  scheduled: 'Agendado',
  in_progress: 'Em andamento',
  paused: 'Pausado',
  awaiting_validation: 'Aguardando validação',
  finished: 'Finalizado',
  cancelled: 'Cancelado',
})

export const machineServiceObject = z.object({
  id: z.string().uuid(),
  code: z.number().int().positive(),
  residenceId: z.string().uuid(),
  heavyMachineryId: z.string().uuid(),
  operatorId: z.string().uuid(),
  citizenId: z.string().uuid(),
  estimatedHours: z.number().int().positive(),
  serviceType: z.string(),
  serviceDate: dateOrIsoString(),
  startTime: dateOrIsoString(),
  endTime: dateOrIsoString(),
  hourPrice: z.number(),
  totalPrice: z.number().nullish(),
  status: machineServiceStatus,
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  operator: operatorObject.nullish(),
  residence: residenceObject.nullish(),
  sourceFilter: z.string().nullish(),
  heavyMachinery: heavyMachineryObject.nullish(),
  citizen: citizenObject
    .pick({
      id: true,
      fullName: true,
      nickname: true,
      socialName: true,
      whatsapp: true,
      alternatePhone: true,
      sex: true,
      isResponsible: true,
    })
    .nullish(),
})

export const machineServiceCreateInputObject = z.object({
  id: z.string().uuid().nullish(),
  residenceId: z.string().uuid(),
  heavyMachineryId: z.string().uuid(),
  operatorId: z.string().uuid(),
  citizenId: z.string().uuid(),
  estimatedHours: z.number().int().positive(),
  serviceType: z.string().min(1),
  serviceDate: dateOrIsoString(),
  startTime: dateOrIsoString(),
  endTime: dateOrIsoString(),
  hourPrice: z.number(),
  status: machineServiceStatus.nullish(),
})

export const machineServiceUpdateInputObject = z.object({
  id: z.string().uuid(),
  residenceId: z.string().uuid().optional(),
  heavyMachineryId: z.string().uuid().optional(),
  operatorId: z.string().uuid().optional(),
  citizenId: z.string().uuid().optional(),
  estimatedHours: z.number().int().positive().optional(),
  serviceType: z.string().min(1).optional(),
  serviceDate: dateOrIsoString().optional(),
  startTime: dateOrIsoString().optional(),
  endTime: dateOrIsoString().optional(),
  hourPrice: z.number().optional(),
  status: machineServiceStatus.optional(),
  sourceFilter: z.string().nullish(),
})

export type MachineServiceType = z.infer<typeof machineServiceObject>
